<div class="container">
  <div class="feedback-form-container">
    <div *ngIf="isLoggedinUser">
      <vs-loggedin-feedback-form></vs-loggedin-feedback-form>
    </div>
    <div *ngIf="!isLoggedinUser">
      <vs-guest-feedback-form></vs-guest-feedback-form>
    </div>
  </div>
</div>
